import * as React from 'react'

function SvgIconPalette(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="palette" aria-labelledby="t-palette d-palette">
        <title id="t-palette">{'Palette'}</title>
        <desc id="d-palette">
          {'A thin board to be held in the hand to mix paints'}
        </desc>
        <path d="M16 5c8.3 0 15 4.9 15 11 0 1.7-1.4 4-2.5 4-.3 0-.5-.1-.8-.4-2-1.8-4.4-3-6.3-3-1.301 0-2.301.5-2.7 1.4-.2.6-.4 1.8 1.2 3.3 1.3 1.2 1.8 2.4 1.396 3.4C20.8 26.1 18.6 27 16 27 7.7 27 1 22.1 1 16S7.7 5 16 5m0-1C7.2 4 0 9.4 0 16s7.2 12 16 12c5.6 0 8.6-3.5 4.6-7.3-1.896-1.8-1.1-3 .801-3 1.5 0 3.604.8 5.699 2.7.5.5 1 .699 1.5.699 1.9 0 3.5-3 3.5-5C32 9.4 24.8 4 16 4z" />
        <path d="M16 22c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1m0-1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM5.4 11.5c.4-.3.3-.8 1.3-.6 1 .2 3.1.9 3 1.5-.1.6 0 1.9-.4 1.8-.4-.1-.3-.9-.8-.9s-1.3.7-1.2 1.1c.1.5-1.3-.2-1.4-.7s-1.4-1.5-.5-2.2zm6.5-4c-.6.8-.3 1.7.5 2.1.8.4 3 2 3.2 1.5.3-.4-.2-1.7-.3-2.3-.1-.6-.1-1-1.1-1.4s-1.5-1.1-2.3.1zM5.8 17.6c.6.1 1.7.6 1.8 1.3.1.7-.5 2.9-1.1 2.8-.6-.101-2-.3-2-1.2 0-.8-.2-2-.6-2.3s-.8-1.2 0-1.3c.8-.1 1.4.6 1.9.7zM21.5 7.4c-.2 0-2.1.1-2 .6s-1 1.2-.7 1.6.601 1.2 1.3 1.3c.7 0 2.5-.1 2.4-.5s0-1.2.2-1.4c.3-.2-.7-1.6-1.2-1.6zm3.6 4.7c-.3.5-1.6.7-1.5 1.3 0 .5.2 1.7.801 1.8.604.1 1.104-.2 1.399-.3.3-.1 1.2 0 1.3.3.104.3 1 .7 1 0s-.5-2.1-.699-2.4c-.201-.3-1.901-1.3-2.301-.7z" />
      </g>
    </svg>
  )
}

export default SvgIconPalette
